/*
 * @Author: kiwi_myl
 * @Description: Do not edit
 * @Date: 2020-11-06 11:34:12
 * @LastEditTime: 2021-05-28 16:19:59
 * @FilePath: /wedsVue/visito/src/api/account.ts
 */
import http from "@/utils/http";
import base from "./base";
import { to } from "@/utils/main";

const Account = {
  /**
   * 登录
   *
   * @param {object} data
   * @returns Array[error,response]
   */
  login(data: any) {
    return to(http.post(`${base.ali}/loginCheck`, data));
  },
  /**
   * 获取上传token
   *
   * @param {object} data
   * @returns Array[error,response]
   */
  getToken() {
    return http.get(`${base.ali}user/getQiniuUploadToken`, {
        params: {
          isOverride: 1,
          expireSeconds: 3600
        }
      })
  },
  /**
   * 获取上传token
   *
   * @param {object} data
   * @returns Array[error,response]
   */
  getAliToken() {
		return http.get(`${base.alis}alioss/token`, {
			params: {
				isOverride: 1,
				expireSeconds: 3600
			}
		})
  },
  /**
   * 图片上传到七牛
   *
   * @param {object} data
   * @returns Array[error,response]
   */
  uploadImgToQiniu(data: any) {
    return to(http.post(`http://upload.qiniup.com/`, data));
  },

  /**
  * 查询是否需要审批以及审批等级
  *https://wxk12dev.12kcool.com/web/bepf/visit/v1/visitorAuditing/queryVisitorAuditing/101014
   
  * @param {object} data
  * @returns Array[error,response]
  */
  visitorAuditing(data: any) {
    return to(
      http.get(
        `${base.ali}${base.visitor}visitorAuditing/queryVisitorAuditing/${data}`
      )
    );
  },
  /**
   * 获取被访人列表
   * @param {object} data
   * @returns Array[error,response]
   */
  get_teacher_list_new(params: any) {
    return to(http.get(`${base.alis}userInfo/get_teacher_list_by_visitor`, { params }));
  },
  /**
  * //查询人脸照片接口：get 参数：手机号
  * https://wxk12dev.12kcool.com/web/bepf/visit/v1/visitorAuditing/queryPicture/15266698887
  
  * @param {object}
  * @returns Array[error,response]
  */
  getQueryPicture(data: any) {
    return to(
      http.get(`${base.ali}${base.visitor}visitorAuditing/queryPicture/${data}`)
    );
  },
  /**
  * //提交表单访客信息
  * 
  https://wxk12dev.12kcool.com/web/bepf/visit/v1/visitorAuditing
  * @param {object}
  * @returns Array[error,response]
  */
  addVisitorAuditing(data: any) {
    return http.post(`${base.ali}${base.visitor}visitorAuditing`, data);
  },
  /**
  * //审批详情
  * 
  https://wxk12dev.12kcool.com/web/bepf/visit/v1/visitorAuditing/queryVisitorInfo?touser_id=230394&school_id=101184&page=1
  * @param {object}
  * @returns Array[error,response]
  */
  getQueryVisitorInfo(params: any) {
    return to(
      http.get(`${base.ali}${base.visitor}visitorAuditing/queryVisitorInfo`, {
        params
      })
    );
  },

  /**
  * //审批详情
  * 
  https://wxk12dev.12kcool.com/web/bepf/visit/v1/visitorAuditing/queryVisitorInfo?touser_id=230394&school_id=101184&page=1
  * @param {object}
  * @returns Array[error,response]
  */
  getVisitorInfoDetail(id: any) {
    return to(
      http.get(
        `${base.ali}${base.visitor}visitorAuditing/visitorInfoDetail/${id}`
      )
    );
  },

  /**
  * //审批
  * 
  https://wxk12dev.12kcool.com/web/bepf/visit/v1/visitorAuditing/approve/1273155631364255746/2
  
  * @param {object}
  * @returns Array[error,response]
  */
  setApprove(id: any, status?: number, params?: any) {
    return to(
      http.get(
        `${base.ali}${base.visitor}visitorAuditing/approve/${id}/${status}`,
        { params }
      )
    );
  },
  /**
  * //验证教师信息
  * 
  https://wxk12dev.12kcool.com/web/bepf/visit/v1/visitorAuditing/check/3/101014?touser_name=李木&touser_tel=18810849715
  
  * @param {object}
  * @returns Array[error,response]
  */
  getCheck(id: any, school_id: any, params: any) {
    return http.get(
      `${base.ali}${base.visitor}visitorAuditing/check/${id}/${school_id}`,
      { params }
    );
  },
  /**
  * //获取学校配置
  * 
  https://wxk12dev.12kcool.com/web/bepf/visit/v1/visitorAuditing/check/3/101014?touser_name=李木&touser_tel=18810849715
  
  * @param {object}
  * @returns Array[error,response]
  */
  getConfig(school_id: any) {
    return http.get(
      `${base.gateway}school/${school_id}/config`
    );
  },
  /**
  * 协议确认接口
  * @param {object}
  * @returns Array[error,response]
  */
  setProtocol(data: any) {
    return to(http.post(`${base.gateway}protocol/status/set`, data));
  },
  /**
  * //访客输入来访选择
  * 
  https://wxk12dev.12kcool.com/web/bepf/visit/v1/visitorAuditing/check/3/101014?touser_name=李木&touser_tel=18810849715
  
  * @param {object}
  * @returns Array[error,response]
  */
  getCodeItem(params: any) {
    return to(http.get(`${base.ali}code/getItem`, { params }));
  },


    /**
  * 登录次数统计
  * 
  * @param {object}
  * @returns Array[error,response]
  */
 getanalyseUv(params: any) {
    return to(http.get(`${base.alis}login_analyse/uv`, { params }));
  },
  
  
};

export default Account;
